import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "medexpert-star",
  "use": "medexpert-star-usage",
  "viewBox": "2 2 20 20",
  "content": "<symbol viewBox=\"2 2 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"medexpert-star\">\r\n<path d=\"M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z\" fill=\"#ffc805\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol